import { render, staticRenderFns } from "./Fashion.vue?vue&type=template&id=5ea2a62f&scoped=true&"
import script from "./Fashion.vue?vue&type=script&setup=true&lang=js&"
export * from "./Fashion.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Fashion.vue?vue&type=style&index=0&id=5ea2a62f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea2a62f",
  null
  
)

export default component.exports